<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8">
      <div class="vx-row">
        <div
          class="vx-col md:w-1/4 sm:w-1/2 w-full"
          v-if="actor.privilege <= 3"
        >
          <label class="text-sm opacity-75">Device</label>
          <v-select
            :options="deviceList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.device"
            @search="searchDevice"
            class="mb-4 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Filter</label>
          <v-select
            :options="dateList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.dateOption"
            class="mb-2 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">Start Time</label>
          <flat-pickr
            :disabled="disableDate"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              maxDate: maxDate,
              time_24hr: true,
              defaultHour: 0
            }"
            style="width: 100%"
            v-model="filter.start_time"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">End Time</label>
          <flat-pickr
            :disabled="disableDate"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              maxDate: maxDate,
              time_24hr: true,
              defaultHour: 23,
              defaultMinute: 59
            }"
            style="width: 100%"
            v-model="filter.end_time"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mt-2">
          <vs-button
            :disabled="loading"
            id="searchBtn"
            style="width: 100%"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="pl-5 mt-1 vs-con-loading__container"
            @click="search"
            >Search</vs-button
          >
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button
            v-if="data.length > 0"
            id="exportBtn"
            icon-pack="feather"
            icon="icon-file-text"
            color="success"
            type="gradient"
            class="mb-4 md:mb-0 vs-con-loading__container"
            @click="handleDownload"
            >Export Data</vs-button
          >
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(250)">
              <span>250</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(500)">
              <span>500</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(1000)">
              <span>1000</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(10000)">
              <span>10000</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <div class="table-container">
        <el-table
          :data="data"
          :sort-by="sort_by"
          border
          :height="data.length > 0 ? 1200 : 135"
          style="
            width: 100%;
            margin-top: 10px;
            margin-bottom: 10px;
            border-left: 1px solid #ccc;
          "
        >
          <el-table-column
            label="No"
            width="68"
            type="index"
            :index="indexMethod"
          >
          </el-table-column>
          <el-table-column
            prop="alarm_name"
            label="Info Alarm"
            sortable
            width="250"
          >
          </el-table-column>
          <el-table-column prop="plate" label="Plate" sortable width="150">
          </el-table-column>
          <el-table-column prop="imei" label="Imei" sortable width="200">
          </el-table-column>
          <el-table-column
            prop="driver_name"
            label="Owner"
            sortable
            width="400"
          >
          </el-table-column>

          <el-table-column prop="param" label="Text" sortable width="170">
          </el-table-column>
          <el-table-column prop="time" label="Date" sortable width="250">
          </el-table-column>

          <el-table-column></el-table-column>

          <div
            slot="append"
            v-if="data.length < 1 || loading"
            class="table_empty"
          >
            {{ loading ? 'Loading....' : 'No Data Available' }}
          </div>
        </el-table>
        <vs-pagination :total="n_page" v-model="page" goto></vs-pagination>
      </div>
    </div>
  </div>
</template>

<style>
[dir='ltr'] .el-table .cell {
  padding-left: 10px;
  padding-right: 10px;
}

.el-table thead {
  color: #ffff;
  font-weight: bold;
}

[dir] .el-table--border::after,
[dir] .el-table--group::after,
[dir] .el-table::before {
  background-color: #ccc;
}

[dir] .el-table th.el-table__cell {
  background-color: #eee;
  font-size: 14px;
  color: #626262;
}

[dir] .el-table tr:active .el-table__cell {
  background-color: rgb(198, 198, 198);
}

[dir] .el-table td.el-table__cell,
[dir] .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #ccc;
}

[dir] .el-table .ascending .sort-caret.ascending {
  border-bottom-color: #ffff;
}

[dir] .el-table .descending .sort-caret.descending {
  border-top-color: #ffff;
}

.el-table--border .el-table__cell,
[dir='ltr']
  .el-table__body-wrapper
  .el-table--border.is-scrolling-left
  ~ .el-table__fixed {
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;
}

[dir] .el-table .el-table__cell {
  padding: 7px 0;
}

.el-table__empty-block {
  display: none !important;
}

.table_empty {
  text-align: center;
  font-size: 13px;
  padding: 10px;
  border-left: 1px solid #ccc;
}

.table_total {
  padding: 10px;
  border-left: 1px solid #ccc;
}
</style>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import FileDownload from 'js-file-download'

export default {
  components: {
    flatPickr,
    vSelect
  },

  data() {
    return {
      data: [],
      token: '',
      action: '',
      loading: false,
      actor: '',
      tempId: 0,

      disableDate: true,
      filter: {
        device: '',
        start_time: null,
        end_time: null,
        today: '',
        dateOption: { value: '', label: '-- Select Filter --' }
      },

      filtered: {
        device: '',
        start_time: null,
        end_time: null,
        today: '',
        dateOption: { value: '', label: '-- Select Filter --' }
      },

      deviceList: [],

      dateList: [
        { value: '', label: '-- Select Filter --' },
        { value: 'today', label: 'Today' },
        { value: 'yesterday', label: 'Yesterday' },
        { value: 'define', label: 'Select Date' }
      ],

      page: 1,
      per_page: 1000,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error',
      today: '',
      yesterday: '',
      twoDaysAgo: '',

      maxDate: '',

      sort_by:
        ({ prop: 'alarm_name', order: 'descending' },
        { prop: 'plate', order: 'descending' },
        { prop: 'imei', order: 'descending' },
        { prop: 'driver_name', order: 'descending' },
        { prop: 'param', order: 'descending' },
        { prop: 'time', order: 'descending' }),

      filename: 'Summary Alarm Report',
      autoWidth: true,
      bookType: 'xlsx'
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    dateOption() {
      return this.filter.dateOption ? this.filter.dateOption.value : ''
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    dateOption() {
      let today = new Date()
      let yesterday = new Date(today)

      yesterday.setDate(yesterday.getDate() - 1)
      today = this.formatDate(today.toDateString())
      yesterday = this.formatDate(yesterday.toDateString())

      this.disableDate = true
      if (this.dateOption == 'today') {
        this.filter.start_time = this.today + ' 00:00'
        this.filter.end_time = this.today + ' 23:59'
        this.maxDate = this.today + ' 23:59'
      } else if (this.dateOption == 'yesterday') {
        this.filter.start_time = this.yesterday + ' 00:00'
        this.filter.end_time = this.yesterday + ' 23:59'
        this.maxDate = this.yesterday + ' 23:59'
      } else {
        this.filter.start_time = ''
        this.filter.end_time = ''
        this.maxDate = this.today + ' 23:59'
        // this.maxDate = this.twoDaysAgo + ' 23:59'
        this.disableDate = false
      }
    }
  },

  created() {
    let today = new Date()
    let yesterday = new Date(today)
    let twoDaysAgo = new Date(today)

    yesterday.setDate(yesterday.getDate() - 1)
    twoDaysAgo.setDate(twoDaysAgo.getDate() - 2)

    this.today = this.formatDate(today.toDateString())
    this.yesterday = this.formatDate(yesterday.toDateString())
    this.twoDaysAgo = this.formatDate(twoDaysAgo.toDateString())

    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        // this.searchDevice('')
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {},

  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.per_page + (index + 1)
    },

    updatePerPage(n) {
      this.per_page = n
    },

    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('-')
    },

    searchDevice(keyword) {
      if (this.actor.privilege >= 4) {
        this.getDataDevice(keyword)
      } else {
        if (keyword.length >= 3) {
          this.getDataDevice(keyword)
        } else {
          this.deviceList = []
        }
      }
    },

    getDataDevice(keyword) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }

      this.timer = setTimeout(() => {
        this.$http
          .get(
            `${this.$api.endpoint}/tracking/search?keyword=${keyword}&type=vehicle`,
            {
              headers: {
                Authorization: `Bearer ${this.token}`
              }
            }
          )
          .then((res) => {
            this.deviceList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      }, 1000)
    },

    initTable() {
      this.data = []
      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/report/summary_alarm`, {
          params: {
            page: this.page,
            per_page: this.per_page,
            device: this.filter.device ? this.filter.device.value : '',
            start: `${this.filter.start_time}:00`,
            end: `${this.filter.end_time}:00`
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.loading = false
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)

          this.row_total = res.data.message.total
          this.data = res.data.message.data

          this.data.map((item, index) => {
            this.data[index].no = index + 1
          })
        })
        .catch((error) => {
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
          this.loading = false
          this.$gf.httpErrorHandler(error)
        })
    },

    search() {
      this.loading = true
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#searchBtn',
        scale: 0.45
      })

      this.filtered.device = this.filter.device
      this.filtered.start_time = this.filter.start_time
      this.filtered.end_time = this.filter.end_time

      this.page = 1
      this.initTable()
    },

    getAddress() {
      this.data.map((item, index) => {
        // if (!item.address) {
        setTimeout(() => {
          this.$http
            .get(`${this.$api.base_url}/api/address`, {
              params: {
                latitude: item.lat,
                longitude: item.lon
              }
            })
            .then((res) => {
              this.data[index].address = res.data.message
            })
        }, index * 300)

        // }
      })
    },

    getAddress2(item, index, param) {
      this.$http
        .get(`${this.$api.base_url}/api/address`, {
          params: {
            latitude: item.lat,
            longitude: item.lon
          }
        })
        .then((res) => {
          this.data[index][param] = res.data.message
        })
    },

    streetView(lat, lon) {
      let url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat}%2C${lon}&heading=-45&pitch=38&fov=80`

      window.open(
        url,
        '_blank',
        'toolbar=1, scrollbars=1, resizable=1, width=' + 800 + ', height=' + 500
      )
    },

    handleDownload() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtn',
        scale: 0.45
      })

      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          'No',
          'Info Alarm',
          'Plate',
          'Imei',
          'Owner',
          'Text',
          'Date'
        ]

        const filterVal = [
          'no',
          'alarm_name',
          'plate',
          'imei',
          'driver_name',
          'param',
          'time'
        ]

        const list = this.data
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    }
  }
}
</script>
